import * as React from 'react';

export const ArrowDownIcon: React.FunctionComponent<{
  color: string;
  ariaName?: string;
}> = ({ color, ariaName }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <title>{ariaName}</title>
      <path
        d="M7.85355 9.14645C7.65829 8.95118 7.34171 8.95118 7.14645 9.14645C6.95118 9.34171 6.95118 9.65829 7.14645 9.85355L12.0962 14.8033C12.2915 14.9986 12.608 14.9986 12.8033 14.8033L17.753 9.85355C17.9483 9.65829 17.9483 9.34171 17.753 9.14645C17.5578 8.95118 17.2412 8.95118 17.0459 9.14645L12.4497 13.7426L7.85355 9.14645Z"
        fill={color}
      />
    </svg>
  );
};
